import script from "./us.vue?vue&type=script&setup=true&lang=ts"
export * from "./us.vue?vue&type=script&setup=true&lang=ts"

import "./us.vue?vue&type=style&index=0&id=b942b47a&lang=scss"

const __exports__ = script;

export default __exports__